import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { AddOrgLicense } from '../models/add-org-license'
import { Injectable } from '@angular/core'
import { EditFmoAbstractGateway } from './edit-fmo-abstract-gateway'
import { NewOrgModel } from '../models/new-org-model'
import { OrgTableModel } from '../models/org-table-model'
import { OrgTrainingModel } from '../models/org-training-model'
import { OrgSettingsModel } from '../models/org-settings-model'
import { AppFeatureSettingValue } from '../models/app-feature-setting-value'
import { OrgLicense } from '../models/org-license'
import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'
import { OrgTableFilter } from '../models/orgTable-filter'

@Injectable()
export class EditFmoGateway extends EditFmoAbstractGateway {
    constructor(private http: HttpClient) {
        super()
    }

    getOrgDetail(organizationid: number): Observable<NewOrgModel> {
        return this.http.get<NewOrgModel>('../api/getOrgData/' + organizationid)
    }

    updateOrgData(model: NewOrgModel): Observable<any> {
        let body = JSON.stringify(model)
        return this.http.post<any>('../api/edit', body)
    }

    getOrgTable(filter: OrgTableFilter): Observable<OrgTableModel[]> {
        let body = JSON.stringify(filter)
        return this.http.post<OrgTableModel[]>('../api/getOrgTable/', body)
    }
    getOrgTraining(orgId: number): Observable<OrgTrainingModel[]> {
        return this.http.get<any>('../api/getOrgTraining?orgid=' + orgId)
    }
    getOrgSettings(orgId: number, featureName: string): Observable<OrgSettingsModel[]> {
        return this.http.get<any>('../api/getFMOSettings/' + orgId + '/' + featureName)
    }
    getOrgSettingValueBySettingName(orgId: number, featureName: string, settingName: string): Observable<OrgSettingsModel[]> {
        return this.http.get<any>('../api/getFMOSettings/' + orgId + '/' + featureName + '/' + settingName)
    }

    insertOrgTraining(model: OrgTrainingModel): Observable<any> {
        let body = JSON.stringify(model)
        return this.http.post<any>('../api/insertOrgTraining', body)
    }
    deleteOrgTraining(orgCourseId: number, orgId: number): Observable<any> {
        return this.http.get<any>('../api/deleteOrgTraining?orgCourseId=' + orgCourseId + '&orgId=' + orgId)
    }
    deleteOrgPlan(cagId: number, orgId: number, planyear: string): Observable<any> {
        console.log('In delete orgId plan ServiceWorker')
        return this.http.get<any>('../api/deleteorgplan?cagID=' + cagId + '&orgId=' + orgId + '&planyear=' + planyear)
    }

    saveFmoSetting(fmoSettingModel: OrgSettingsModel[]): Observable<any> {
        let request = JSON.stringify(fmoSettingModel)
        return this.http.post<any>('../api/insertOrUpdateFMOSetting', request)
    }

    getOrgAppFeatureSettingValues(orgId: number, featureName: string, settingName: string): Observable<AppFeatureSettingValue[]> {
        let getUrl = '../api/getOrgAppFeatureSettingValue/' + orgId + '/' + featureName + '/' + settingName
        return this.http.get<AppFeatureSettingValue[]>(getUrl)
    }

    getOrgLicenses(orgId: number): Observable<OrgLicense[]> {
        let getUrl = '../api/getOrgLicenses/' + orgId
        return this.http.get<OrgLicense[]>(getUrl)
    }

    addOrgLicenses(model: AddOrgLicense): Observable<any> {
        let body = JSON.stringify(model)
        return this.http.post<any>('../api/addOrgLicenses', body)
    }

    addAllOrgLicenses(model: AddOrgLicense): Observable<any> {
        let body = JSON.stringify(model)
        return this.http.post<any>('../api/addAllOrgLicenses', body)
    }

    deleteOrgLicense(orgLicenseId: number, orgId: number): Observable<any> {
        console.log('In delete orgId license ServiceWorker')
        return this.http.get<any>('../api/deleteOrgLicenses?orgLicenseID=' + orgLicenseId + '&orgId=' + orgId)
    }

    getAllLicenseStatus(): Observable<ValidatedSelectOptionModel[]> {
        let URL = '../api/GetLicenseStatus'
        return this.http.get<ValidatedSelectOptionModel[]>(URL)
    }
}
